import { useEffect, PropsWithChildren } from 'react';
import { FormProvider, UseFormReturn, Path } from 'react-hook-form';
import { SiteDiscoveryValues } from '../../../../../../store/features/discovery';

export interface SiteSearchProviderProps<T> {
  form: UseFormReturn<Partial<T>>;
  onChangeFilter: (data: T, name?: Path<Partial<T>>) => void;
}

export function SiteSearchProvider<T extends Partial<SiteDiscoveryValues>>(
  props: PropsWithChildren<SiteSearchProviderProps<T>>,
) {
  const { form, onChangeFilter, children } = props;
  const { watch } = form;

  useEffect(() => {
    const subscription = watch((data, { name }) => {
      onChangeFilter(data as unknown as T, name);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [watch, onChangeFilter]);

  return <FormProvider {...form}>{children}</FormProvider>;
}
